<script setup>
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { SwButton } from '@getswish/design-library-web';
import { computed } from 'vue';

const props = defineProps({
  fields: {
    type: Object,
    default: () => {},
  },
});

const renderedText = computed(() => documentToHtmlString(props.fields.text));
const image = computed(() => (props.fields.images ? props.fields.images[0] : null));
const hasButton = computed(() => props.fields.buttonLink && props.fields.buttonText);
</script>

<template>
  <div class="content">
    <img class="image" v-if="image" :src="image.fields.file.url" :alt="image.fields.title" />

    <h1>{{ fields.heading }}</h1>

    <div class="text" v-html="renderedText" />

    <SwButton v-if="hasButton" element="a" :label="fields.buttonText" :href="fields.buttonLink" />
  </div>
</template>

<style lang="scss" scoped>
h1 {
  @include tertiary-title-medium;
}

.text {
  :deep(p) {
    @include primary-text-regular;
    margin-top: 0;
  }
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
</style>
